import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Menu from './Components/Menu';
import Footer from './Components/Footer';
import Blank from './Pages/Blank';
import Header from './Components/Header';
import Profile from './Pages/Profile';
import Login from "./Pages/Login";
import Portal from "./Pages/Portal";
import Nosub from "./Pages/Nosub";
//import Menu from '../Components/Menu';


ReactDOM.render(
  <BrowserRouter>
<Header />
<Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />    
        <Route path="/index" element={<Portal />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/profile" element={<Profile/>} />

      </Routes>
      <Footer/>
</BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
